export * from './ion-affix.module';
export * from './directives/ion-affix';
